import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class ProcessStepChunkEvent extends ConnectBasicEntity {
chunkEvent: string;
chunkOperation: string;
condition: string;
processCode: string;
processStepCode: string;
visionCode: string;
waitTime: number | null;
}

